export const explore = {
  title: 'Explorer DONKEY TRAVEL',
  subtitle: 'Découvrez les destinations tendances et les membres populaires',
  stats: {
    title: 'Notre Communauté en Chiffres',
    members: 'Membres Actifs',
    countries: 'Pays',
    exchanges: 'Échanges Réalisés',
    satisfaction: 'Satisfaction'
  },
  trending: {
    title: 'Destinations Tendances',
    subtitle: 'Les destinations les plus populaires ce mois-ci',
    members: 'membres',
    properties: 'logements',
    viewAll: 'Voir toutes les destinations',
    explore: 'Explorer'
  },
  newMembers: {
    title: 'Nouveaux Membres Cette Semaine',
    subtitle: 'Bienvenue à nos nouveaux membres',
    joined: 'Inscrit le',
    viewProfile: 'Voir le profil',
    exchanges: 'échanges',
    rating: 'Note',
    contact: 'Contacter'
  },
  featured: {
    title: 'Coups de Cœur de la Communauté',
    subtitle: 'Sélectionnés par nos membres',
    exchanges: 'échanges',
    rating: 'note',
    discover: 'Découvrir',
    viewProfile: 'Voir le profil',
    superHost: "Hôte d'exception"
  },
  seasonal: {
    title: 'Disponibilité Saisonnière',
    subtitle: 'Trouvez le moment parfait pour votre échange',
    spring: 'Printemps',
    summer: 'Été',
    autumn: 'Automne',
    winter: 'Hiver',
    available: 'logements disponibles',
    search: 'Rechercher',
  },
  personalized: {
    title: 'Recommandé Pour Vous',
    subtitle: 'Basé sur votre historique de navigation et vos préférences',
    match: 'compatibilité',
    seeMore: 'Voir plus de recommandations',
    viewAll: 'Voir toutes les recommandations',
    based: 'Basé sur vos préférences'
  },
  filters: {
    all: 'Tous',
    beach: 'Plage',
    mountain: 'Montagne',
    city: 'Ville',
    countryside: 'Campagne',
    luxury: 'Luxe',
    family: 'Familial'
  }
};
